// Data-viz series ramp from the v1 Figma donut/ledger palette. Consumers
// index by series position; the tokens live in packages/ui globals.css.
const ROWA_CHART_COLORS = [
  'var(--color-rowa-chart-1)',
  'var(--color-rowa-chart-2)',
  'var(--color-rowa-chart-3)',
  'var(--color-rowa-chart-4)',
  'var(--color-rowa-chart-5)',
  'var(--color-rowa-chart-6)',
  'var(--color-rowa-chart-7)'
] as const;

export function chartColor(index: number): string {
  return ROWA_CHART_COLORS[index % ROWA_CHART_COLORS.length]!;
}
